import React, { createContext, useContext } from 'react';
export function useFeatureFlags() {
    return useContext(FeatureFlagsContext);
}
export function FeatureFlagsProvider({ featureFlags, children }) {
    return (React.createElement(FeatureFlagsContext.Provider, { value: Object.assign({}, featureFlags) }, children));
}
export const FEATURE_FLAGS_ID_ATTRIBUTE = 'BXP_CONTENT_FEATURE_FLAGS';
const FeatureFlagsContext = createContext({});
//# sourceMappingURL=use-feature-flags.js.map